import React from "react";
import {
    UncontrolledCollapse
  } from "reactstrap";
export default class LineExplanation extends React.Component {
  constructor() {
    super();
    this.state = { explanations: [] };
  }

  componentDidMount() {
    const comp = this;
    fetch(
      "http://www.almotanabbi.com/ws1.0/getLineExplanationsList.do?lineId=" +
        this.props.lineId
    ).then(response => {
      response.json().then(explanations => {
        comp.setState({ open: true, loaded: true, explanations: explanations });
      });
    });
  }

  removePoemsSeparatorImages(content) {
    content =  content.replace(/<img src="..\/icons\/pixel.gif" class="poetry1Image">/gi, "");
    content =  content.replace(/<img src="..\/icons\/pixel.gif" class="poetry2Image">/gi, "");
    content =  content.replace(/<img src="..\/icons\/pixel.gif" class="poetry2SpaceImage">/gi, "");
      return content;
  }

  render() {
    return (
      <div style={{ paddingRight: "35px",fontSize:'small'}}>
        {this.state.explanations &&
          this.state.explanations.map((explanation, index) => (
            <div key={index} style={{textAlign:'center'}}>
            * <a id={'explanation'+explanation.explanationId} style={{color:'blue',cursor:'pointer'}}>{explanation.book.bookTitle}</a>
              <UncontrolledCollapse toggler={'#explanation'+explanation.explanationId} style={{paddingRight:'20px',borderWidth:'1px',borderStyle:'solid', borderColor:'#E0E0E0',borderRadius:'10px',padding:'10px'}}>
              <p dangerouslySetInnerHTML={{__html:this.removePoemsSeparatorImages(explanation.contentHtml)}}/>
                الشارح: {explanation.book.explainer.fullName} {explanation.book.explainer.nickName}
              {explanation.book.checker && <React.Fragment><br />المحقق: {explanation.book.checker}</React.Fragment>}
              {explanation.book.city && <React.Fragment><br />المدينة: {explanation.book.city}</React.Fragment>}
              {explanation.book.country && <React.Fragment><br />الدولة: {explanation.book.country}</React.Fragment>}
              {explanation.book.publisher && <React.Fragment><br />دار النشر: {explanation.book.publisher}</React.Fragment>}
              {explanation.book.publishingDate && <React.Fragment><br />تاريخ النشر: {explanation.book.publishingDate}</React.Fragment>}
              </UncontrolledCollapse>
            </div>
          ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/LineExplanation.js